import React from 'react'
import UiFileUpload from '../../_uiComponents/telerikComponents/UiFileUpload'
import { Button } from '@progress/kendo-react-buttons'
import { Grid } from "@mui/material";
import SalesDataManagementGrid from './SalesDataManagementGrid'
import UiTopDatePicker from '../../_uiComponents/telerikComponents/UiTopDatePicker'
import UiTopDropDownList from '../../_uiComponents/telerikComponents/UiTopDropDownList'

export default function SalesDataManagement(props) {

  const handleChange = (e) => {
    console.log(e.value)
  }

  const handleSelect = (e) => {
    console.log(e.target.value)
  }

  const salesFileType = [
    {
      label: "File Type 1",
      value: 1,
    },
    {
      label: "File Type 2",
      value: 2,
    },
    {
      label: "File Type 3",
      value: 3,
    }

  ];

  const applicationData = [
    {
      label: "Application 1",
      value: 1,
    },
    {
      label: "Application 2",
      value: 2,
    },


  ];
  return (
    <>

      <Grid container spacing={2} className='sba-telerik-components-wr'>
        <Grid item xs="12" lg="4" sx={{ mt: 1 }}>
          <UiTopDropDownList
            name="application"
            label="Application"
            handleSelect={handleSelect}
            data={applicationData}
            placeholder="Select Application"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className='sba-telerik-components-wr'>
       
        <Grid item xs="12" lg="4" sx={{ mt: 2 }}>
          <UiTopDropDownList
            name="salesFileType"
            label="Sales File Type"
            handleSelect={handleSelect}
            data={salesFileType}
            placeholder="Select File Type"
          />
        </Grid>
        <Grid item xs="12" lg="4" sx={{ mt: 2 }}>
          <UiTopDatePicker
            label="Sales Date"
            name="salesDate"
            handleChange={handleChange}
          />
        </Grid>
        <Grid item xs="12" lg="8" sx={{ mt: 2, mb: 2 }}>
          <UiFileUpload />
        </Grid>
      </Grid>


      <SalesDataManagementGrid />

    </>
  )
}
